import { Options } from "../../common/types/requestOptions";
import { query } from "../../app/query";
import { Paginated, PaginationFilters } from "../../common/types/Paginated";
import { Feedback, UnacknowledgedFeedbacksCount } from "./types/queries";
import { EventPayload } from "../../common/types/Event";
import { command } from "../../app/command";
import { MOCK_FEEDBACKS } from "./constants";
import { delay } from "../../app/common";
import { WorktimeEntryCustomerFeedbackAcknowledged } from "./types/events";
import { AckCustomerFeedbackToEntry } from "./types/commands";

export const feedbacks = (
  filters: PaginationFilters,
  options: Options = {},
): Promise<Paginated<Feedback[]>> =>
  query<PaginationFilters, Paginated<Feedback[]>>(
    "/projections/qry/feedbacks",
    filters,
    options,
  );

export const unacknowledgedFeedbacksCount = (
  _: {},
  options: Options = {},
): Promise<Paginated<Feedback[]>> =>
  query<UnacknowledgedFeedbacksCount, Paginated<Feedback[]>>(
    "/projections/qry/feedbacks",
    { pageSize: 1, notAcknowledged: true },
    options,
  );

export const mockFeedbacks = async (
  filters: PaginationFilters,
  options: Options = {},
): Promise<Paginated<Feedback[]>> => {
  console.log(
    "fetchMockFeedbacks called with filters:",
    filters,
    "options:",
    options,
  );
  await delay(1500);

  return MOCK_FEEDBACKS;
};

export const ackCustomerFeedbackToEntry = async (
  body: AckCustomerFeedbackToEntry,
  options: Options = {},
): Promise<EventPayload<WorktimeEntryCustomerFeedbackAcknowledged>[]> =>
  command<
    AckCustomerFeedbackToEntry,
    WorktimeEntryCustomerFeedbackAcknowledged
  >("/working/cmd/ackCustomerFeedbackToEntry", body, options);
